/* src/app/shared/reset_assignee/reset-assignee.component.css */
div {
  margin: 1em 0;
}
/*# sourceMappingURL=reset-assignee.component.css.map */
